<div class="card-modal" (click)="emitSignCode(signCode)" [class.selected]="selectedSign == signCode">
  <img [src]="signCode | enumSvg: 'Signaling'" alt="" height="40px" width="40px" style="object-fit: contain;">

  <!-- Quantidade -->
  <div class="item-quantity">
    <h3 class="text-white">{{itemQuantity(sign)}}</h3>
  </div>
  <!-- Quantidade -->
</div>
